import web from "../web";

class StatutapprenantService {
    index(token){
        return web.get("/api/statutsapprenants", { headers: { 'Authorization': 'Bearer '+token } })
    } 

    liste(token){
        return web.get("/api/statutsapprenants/liste", { headers: { 'Authorization': 'Bearer '+token } })
    } 

    store(data, token){
        return web.post("/api/statutsapprenants", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/statutsapprenants/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/statutsapprenants/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/statutsapprenants/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new StatutapprenantService()